(function ($, document, window, undefined) {

    'use strict';

    var Modal = function(options){

        var $modal = null

        var openModalHandler = function(e) {
            $.isFunction( options.onBeforeOpen ) && options.onBeforeOpen(e)
            $modal.fadeIn('600').css("display", "flex")
            $.isFunction( options.onAfterOpen ) && options.onAfterOpen(e)
        }

        var closeModalHandler = function(e) {
            $.isFunction( options.onBeforeClose ) && options.onBeforeClose(e)
            $modal.fadeOut('600').css("display", "none")
            $.isFunction( options.onAfterClose ) && options.onAfterClose(e)
        }

        var bindEvents = function() {
            $(document).on("click", options.openTrigger, openModalHandler)
            $(document).on("click", "[data-js=modal-close]", closeModalHandler)
            //$(document).on("keyup", function(e) { console.log(e.key) })
        }

        var init = function() {

            $modal = $("[data-js=modal]");

            options = $.extend({
                onBeforeOpen: function() {},
                onAfterOpen: function() {},
                onBeforeClose: function() {},
                onAfterClose: function() {},
                openTrigger: "[data-js=modal-open]"
            }, options);

            bindEvents()
            
        }()

        
    }

    if (!window.Frontier) window.Frontier = {};
        window.Frontier.Modal = Modal;

}(jQuery, document, window));